
export function parseTotal(total: string) {
    return Number.parseFloat(total) / 100;
}

export function format_total(total: number, currency_code: string) {
    return `${currency_code} ${total.toFixed(2)}`
}


export interface PaddleSubscription {
    status: string;
    next_billed_at: Date;
    cancelled_at: Date;
    management_urls: {
        update_payment_method: string;
        cancel: string;
    };
    is_active: boolean;
    items: {
        price: {
            description: string;
            unit_price: {
                amount: number;
            };
        };
    }[];
    current_billing_period?: {
        starts_at: string;
        ends_at: string;
    } | null;
    next_transaction: {
        details: {
            totals: {
                grand_total: string;
                currency_code: string;
            };
        };
    };
    recurring_transaction_details?: {
        line_items: {
            totals: {
                subtotal: string;
                tax: string;
            };
            unit_totals: {
                subtotal: string
                discount: string
                tax: string
                total: string
            }
        }[];
    };
}

export interface RecurringMemberDetails {
    price: number;
    tax: number;
    currency: string;
}
